import { render } from "./AdministrationRow.vue?vue&type=template&id=53945957&scoped=true"
import script from "./AdministrationRow.vue?vue&type=script&lang=js"
export * from "./AdministrationRow.vue?vue&type=script&lang=js"

import "./AdministrationRow.vue?vue&type=style&index=0&id=53945957&scoped=true&lang=css"

import exportComponent from "C:\\job\\ems-ISO-final\\frontend_ems\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53945957"]])

export default __exports__